module.exports = __webpack_public_path__ + "img/wallet_02_multi_1.b6e76598.png";